<ng-template [ngIf]="menuSezioni && menuSezioni.showMenu">
	<button 
		*ngIf="menuSezioni.upperList.length > 0 || !isTabletSizeScreen" 
		[attr.id]="'togglenavigazioneprincipale'"
		type="button" 
		[attr.data-toggle]="dataToggle" 
		aria-expanded="false">
			Menu
	</button>
		<ul [class]="isDropdown() ? 'dropdown-menu shadow' : ''" id="navigazioneprincipale"
			[attr.aria-labelledby]="'togglenavigazioneprincipale'" role="menu">
			<div id="voci_menu_wrapper" class="ctx">
				<li *ngFor="let opt of menuOptions; let i = index" [ngClass]="{
						'active': (opt.url === router.url.substring(1, router.url.length)),
						'disabled': opt.disabled
					}" [class]="opt.class[0]" role="none">
					<div *ngIf="!opt.disabled; else disabled">
						<a *ngIf="!opt.modal; else hasModal" href="#" (click)="onClickMenuLink()" [routerLink]="opt.url"
							[title]="opt.label" role="menuitem" tabindex="0" [attr.aria-disabled]="opt.disabled ? 'true' : null"
							(keydown)="onKeydown($event, i)">
							{{ opt.label }}
						</a>
		
						<ng-template #hasModal>
							<a href="#" (click)="onClickMenuLink(true)" [attr.data-toggle]="'modal'"
								[attr.data-target]="opt.target" [title]="opt.label" role="menuitem" tabindex="0"
								(keydown)="onKeydown($event, i)">
								{{ opt.label }}
							</a>
						</ng-template>
					</div>
		
					<ng-template #disabled>
						<span role="menuitem" aria-disabled="true" tabindex="-1">
							{{ opt.label }}
						</span>
					</ng-template>
				</li>
		
				<ng-container *ngComponentOutlet="dynamicInjection?.component;"></ng-container>
			</div>
		</ul>


	<div *ngIf="!isDropdown() && isDocumentManagementEnabled()" class="upload-tool-wrapper">
		<app-upload-tool (filesList)="onFilesListCollect($event)"></app-upload-tool>
	</div>

	<ng-template [ngIf]="sezioni && menuSezioni && menuSezioni.upperList.length>0">
		<div style="margin-bottom: 40px;" >
			<ul class="contextmenu fadecontainer" [ngClass]="{'dati_generali': menuSezioni.inserimento}">
				<li *ngFor="let voceMenu of menuSezioni.upperList | hideMenuFilter" id="{{voceMenu.id}}"
					[ngClass]="{'active': voceMenu.active, 'mandatory': voceMenu.mandatory, 'grey': voceMenu.grey, 'disabled': voceMenu.disabled}">
					<ng-template [ngIf]="!voceMenu.disabled">
						<a (click)="onClickMenuLink()" routerLink="{{voceMenu.urlInserimento ? voceMenu.urlInserimento: voceMenu.url}}/{{voceMenu.idPratica}}"
							title="Vai a {{voceMenu.descrizione}}">{{voceMenu.descrizione}}</a>
					</ng-template>
					<ng-template [ngIf]="voceMenu.disabled"> <em>{{voceMenu.descrizione}}</em></ng-template>
				</li>
			</ul>
			<ng-template
				[ngIf]="menuSezioni.inserimento && menuSezioni.secondoStadioInserimento && menuSezioni.lowerList.length>0">
				<ul class="contextmenu fadecontainer secondolivello">
					<li *ngFor="let voceMenu of menuSezioni.lowerList | hideMenuFilter" id="{{voceMenu.id}}"
						[ngClass]="{'active': voceMenu.active, 'mandatory': voceMenu.mandatory, 'grey': voceMenu.grey, 'avanzato': !voceMenu.grey, 'disabled': voceMenu.disabled}">
						<ng-template [ngIf]="!voceMenu.disabled">
							<a (click)="onClickMenuLink()" routerLink="{{voceMenu.urlInserimento ? voceMenu.urlInserimento: voceMenu.url}}/{{voceMenu.idPratica}}"
								title="Vai a {{voceMenu.descrizione}}">{{voceMenu.descrizione}}</a>
						</ng-template>
						<ng-template [ngIf]="voceMenu.disabled"> <em>{{voceMenu.descrizione}}</em></ng-template>
					</li>
				</ul>
			</ng-template>
		</div>
	</ng-template>

	<div class="modal fade in" id="modaladdpraticaveloce" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
					<button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal"
						type="button">Chiudi</button>
				</p>
				<!-- <app-creazione-rapida></app-creazione-rapida> -->
			</div>
		</div>
	</div>
</ng-template>

<ng-template [ngIf]="faccettaRequest && faccettaRequest.faccetteApplicabili">
	<button 
		*ngIf="isTabletSizeScreen" 
		[attr.id]="'togglenavigazioneprincipale'"
		type="button" 
		[attr.data-toggle]="dataToggle" 
		aria-expanded="false">
			Menu
	</button>
	<label>
		<p style="margin: 10px;">Affina la ricerca</p>
	</label>
	<ul style="margin-bottom: 40px;" class="contextmenu fadecontainer secondolivello" id="menu_faccette">

		<li *ngFor="let faccetta of faccettaRequest.faccetteApplicabili; let i = index" id="{{faccetta.keyName}}"
			[ngClass]="{'active': true, 'mandatory': false, 'grey': false, 'avanzato': true, 'disabled': false}">

			<label>
				<h5 style="font-size: 12px"><a *ngIf="faccetta.values && faccetta.values.length > 0"
						data-toggle="collapse" [attr.aria-controls]="'subfaccetta'+faccetta.feKeyName"
						href="{{'#subfaccetta'+faccetta.feKeyName}}"
						[attr.aria-expanded]="i === indexPrimaCategoriaFaccette || hasFaccetteSelezionate(faccetta)"
						[class]="(i === indexPrimaCategoriaFaccette || hasFaccetteSelezionate(faccetta)) ? 'collapse_faccette_menu' : 'collapse_faccette_menu collapsed'"><label>{{faccetta.feName}}</label></a>
					<span *ngIf="faccetta.values.length === 0">{{faccetta.feName}}</span>
				</h5>
			</label><br />

			<ul class="collapse" id="subfaccetta{{faccetta.feKeyName}}"
				[ngClass]="(i === indexPrimaCategoriaFaccette || hasFaccetteSelezionate(faccetta)) ? 'in' : ''">
				<li *ngFor="let faccettaVal of faccetta.values" id="{{faccettaVal.valore}}" class="col-sm-12">
					<div *ngIf="faccettaVal.numOccorrenze != 0">
						<p class='active singlecheckbox col-xs-12 col-sm-12' style="margin-left: -20px">
							<input value="{{faccettaVal.valore}}" id="{{faccetta.keyName}},{{faccettaVal.valore}}"
								name="{{faccetta.keyName}},{{faccettaVal.valore}}" type="checkbox"
								(click)="applicaFaccetta(faccetta,faccettaVal,$event);"
								[checked]="isFaccettaSelezionata(faccettaVal.valore,faccetta.keyName)" />
							<label for="{{faccetta.keyName}},{{faccettaVal.valore}}"
								[style.color]="faccettaVal.numOccorrenze == 0 ? '#E4E4E4' : 'grey'">{{faccettaVal.feChildName}}
								({{faccettaVal.numOccorrenze}}/{{faccetteX(faccetta.keyName,faccettaVal.valore)}})</label>
						</p>
					</div>
				</li>
				<div *ngFor="let faccettaVal of faccetta.values; let last = last">

					<li [hidden]="faccettaVal.numOccorrenze != 0">
						<div *ngIf="faccettaVal">
							<div *ngIf="last">

					<li class="glyphicon glyphicon-chevron-down" id="{{faccetta.keyName}}"
						style="text-align:left; margin-left: -20px;" class="btn-accordion btn-sm collapsed"
						data-toggle="collapse" [attr.data-target]="'#' + faccetta.feKeyName">
					</li>

				</div>
				</div>
		</li>
		</div>

		<div id="{{faccetta.feKeyName}}" class="collapse">

			<div *ngFor="let faccettaVal of faccetta.values" id="{{faccettaVal.feChildName}}" class="col-sm-12">

				<div *ngIf="faccettaVal">
					<div *ngIf="faccettaVal.numOccorrenze === 0">

						<p class='active singlecheckbox col-xs-12 col-sm-12' style="margin-left: -35px">
							<input value="{{faccettaVal.valore}}" id="{{faccetta.keyName}},{{faccettaVal.valore}}"
								name="{{faccetta.keyName}},{{faccettaVal.valore}}" type="checkbox"
								(click)="applicaFaccetta(faccetta,faccettaVal,$event);"
								[checked]="isFaccettaSelezionata(faccettaVal.valore,faccetta.keyName)" />
							<label for="{{faccetta.keyName}},{{faccettaVal.valore}}"
								[style.color]="faccettaVal.numOccorrenze == 0 ? '#E4E4E4' : 'grey'">{{faccettaVal.feChildName}}
								({{faccettaVal.numOccorrenze}}/{{faccetteX(faccetta.keyName,faccettaVal.valore)}})</label>
						</p>
					</div>
				</div>
			</div>
		</div>

	</ul>
	</li>
	</ul>
</ng-template>
